import React, { useEffect, useState } from 'react';
import { notifications } from '../../../../constant/Data';
import tincture6 from "../../../../assets/landingPage/lung-renew-6-tincture.png"



const NotificationRotator = () => {
    const keys = Object.keys(notifications);
    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(false);


    useEffect(() => {
        const firstTimeout = setTimeout(() => {
            setVisible(true);
        }, 10000);

        const interval = setInterval(() => {
            setVisible(false);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % keys.length);
                setVisible(true);
            }, 5000);
        }, 10000);

        return () => {
            clearTimeout(firstTimeout);
            clearInterval(interval);
        };
    }, []);

    const current = notifications[keys[index]];

    return (
        <div className={`fixed bottom-6 left-6 transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0'} z-50`}>
            <div className="bg-white shadow-lg rounded-xl p-4 flex items-start space-x-4 w-96 max-w-full">

                <div className="flex-1 text-sm">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center space-x-2 text-gray-400 text-sm font-noraml">
                            <svg fill="#41B8B6" version="1.1" xmlns="https://www.w3.org/2000/svg"
                                viewBox="0 0 489.543 489.543" className="w-4">
                                <g class="saleverify-svg-fill">
                                    <path
                                        d="M270.024,0c-22.6,0-15,48.3-15,48.3s-48.3,133.2-94.5,168.7c-9.9,10.4-16.1,21.9-20,31.3l0,0l0,0c-0.9,2.3-1.7,4.5-2.4,6.5c-3.1,6.3-9.7,16-23.8,24.5l46.2,200.9c0,0,71.5,9.3,143.2,7.8c28.7,2.3,59.1,2.5,83.3-2.7c82.2-17.5,61.6-74.8,61.6-74.8c44.3-33.3,19.1-74.9,19.1-74.9c39.4-41.1,0.7-75.6,0.7-75.6s21.3-33.2-6.2-58.3c-34.3-31.4-127.4-10.5-127.4-10.5l0,0c-6.5,1.1-13.4,2.5-20.8,4.3c0,0-32.2,15,0-82.7C346.324,15.1,292.624,0,270.024,0z">
                                    </path>
                                    <path
                                        d="M127.324,465.7l-35-166.3c-2-9.5-11.6-17.3-21.3-17.3h-66.8l-0.1,200.8h109.1C123.024,483,129.324,475.2,127.324,465.7z">
                                    </path>
                                </g>
                            </svg>
                            <span>Hot Product</span>
                        </div>
                        <span className="text-gray-500 text-xs">{current.time}</span>
                    </div>
                    <div className='flex items-center gap-3'>

                        <div>
                            <p
                                className="text-gray-700"
                                dangerouslySetInnerHTML={{ __html: current.content }}
                            />
                            <div className="mt-2 text-xs text-teal-700 flex items-center space-x-1">
                                <svg xmlns="https://www.w3.org/2000/svg " width="13 "
                                    height="13 " viewBox="0 0 24 24 " fill='#156560'>
                                    <path
                                        d="M12 0c-6.627 0-12 5.373-12
                           12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z ">
                                    </path>
                                </svg>
                                <span>
                                    Verified by <strong className="font-semibold">SaleVerify</strong>
                                </span>
                            </div>
                        </div>


                        <div className="flex-shrink-0">
                            <img
                                className="w-14 h-14 rounded-md object-cover"
                                src={tincture6}
                                alt="product"
                            />
                        </div>



                    </div>



                </div>

            </div>
        </div>
    );
};

export default NotificationRotator;
